export default "__VITE_ASSET__bc2882de__"